import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

const ManageCars = () => {
  const [cars, setCars] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [carToDelete, setCarToDelete] = useState(null);

  // Fetch data from API using axios
  useEffect(() => {
    axios.post('https://genzserver.mylksystems.com/Cars/getAllCarDetails')
      .then((response) => {
        setCars(response.data.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the cars data!", error);
      });
  }, []);

  // Filter cars based on search query
  const filteredCars = cars.filter((car) =>
    (car.CarCategory || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (car.Remark || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Handle image click to open modal
  const handleClickOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  // Handle modal close
  const handleClose = () => {
    setOpen(false);
    setSelectedImage('');
  };

  // Open the delete confirmation dialog
  const handleDeleteClick = (carId) => {
    setCarToDelete(carId);
    setConfirmDelete(true);
  };

  // Close the delete confirmation dialog
  const handleCloseDelete = () => {
    setConfirmDelete(false);
    setCarToDelete(null);
  };

  // Handle deleting the car
  const handleConfirmDelete = () => {
    if (carToDelete) {
      // Make an API call to delete the car
      axios.post('https://genzserver.mylksystems.com/Cars/deleteCar', { carId: carToDelete })
        .then((response) => {
          console.log(response.data);
          setCars(cars.filter((car) => car.carid !== carToDelete));
          handleCloseDelete();
        })
        .catch((error) => {
          console.error("Error deleting car:", error);
          alert('Failed to delete the car. Please try again.');
        });
    }
  };

  return (
    <div className="page-shell">
      <div className="table-toolbar">
        <div>
          <span className="eyebrow"><DirectionsCarIcon fontSize="small" /> Rental fleet</span>
          <h1>Manage cars</h1>
          <p>Review rental categories, passenger capacity, pricing, and vehicle photos.</p>
        </div>

        <TextField
          label="Search cars"
          variant="outlined"
          className="table-search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <TableContainer component={Paper} className="admin-table-card">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Car ID</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Passenger Count</TableCell>
              <TableCell>Remark</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Image</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredCars.map((car) => (
              <TableRow key={car.carid}>
                <TableCell>{car.carid}</TableCell>
                <TableCell>{car.CarCategory}</TableCell>
                <TableCell>{car.PassengetCount}</TableCell>
                <TableCell>{car.Remark}</TableCell>
                <TableCell>{car.rate}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleClickOpen(`https://genzserver.mylksystems.com/Assets/Cars/${car.image}`)} aria-label="View car image">
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    onClick={() => handleDeleteClick(car.carid)}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {filteredCars.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} className="empty-state">
                  No cars match your search.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Car Image</DialogTitle>
        <DialogContent>
          <img src={selectedImage} alt="Car" style={{ width: '100%', height: 'auto', borderRadius: 8 }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this car?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ManageCars;
